<div class="sidebar-wrapper">
  <app-sidebar-header [showBackButton]="false">
    <div smallTitle>Create Registry Entry</div>
    <div mainTitle>REGISTRY ENTRY INFORMATION</div>
  </app-sidebar-header>
  <div class="main-content">
    <form class="flex flex-col flex-1" #submittalEntryForm="ngForm" role="form" [@fadeInGeneral]>
      <div class="flex-1 flex flex-col">
        <!-- Registry ID -->
        <div class="flex justify-between items-center gap-2.5">
          <app-floating-input
            id="registry_id"
            label="Registry ID"
            placeholder="Registry ID"
            name="registry_id"
            [ngModel]="model().custom_id"
            (ngModelChange)="updateModel('custom_id', $event)"
            class="w-full"
            required
            [iconClass]="canEditRegistryId ? 'icon-text-revert' : 'icon-text-edit'"
            [disabled]="!canEditRegistryId"
            (iconClick)="onCanEditRegistryIdIconClick()"
            [isLoading]="nextRegistryIdIsLoading()"
          ></app-floating-input>
        </div>

        <!-- Spec Section -->
        <div class="flex justify-between items-center gap-2.5">
          <app-floating-input
            id="spec_section"
            label="Spec Section"
            placeholder="##.####"
            name="spec_section"
            [ngModel]="model().spec_section"
            (ngModelChange)="updateModel('spec_section', $event)"
            class="w-full"
            required
            [pattern]="SPEC_SECTION_REGEX"
            [filterInputBasedOnPattern]="true"
          ></app-floating-input>
        </div>

        <!-- Spec Description -->
        <div class="flex justify-between items-center gap-2.5">
          <app-floating-input
            id="spec_description"
            label="Spec Description"
            placeholder="Spec Description"
            name="spec_description"
            [ngModel]="model().spec_description"
            (ngModelChange)="updateModel('spec_description', $event)"
            class="w-full"
            required
          ></app-floating-input>
        </div>

        <!-- Item Description -->
        <div class="flex justify-between items-center gap-2.5">
          <app-floating-input
            id="item_description"
            label="Item Description"
            placeholder="Item Description"
            name="item_description"
            [ngModel]="model().item_description"
            (ngModelChange)="updateModel('item_description', $event)"
            class="w-full"
            required
          ></app-floating-input>
        </div>

        <!-- Submittal Owner -->
        <div class="flex justify-between items-center gap-2.5">
          <app-dropdown
            name="submittal_owner"
            [ngModel]="model().owner_id"
            (ngModelChange)="updateModel('owner_id', $event)"
            [options]="invitedSPs()"
            optionLabel="name"
            optionValue="id"
            label="Submittal Owner"
            placeholder="Select Submittal Owner"
            class="w-full"
          >
            <ng-template #selectedContent #optionContent let-option>
              <div class="flex flex-col">
                <div class="text-navy-900 font-semibold">{{ option?.name }}</div>
                <div class="text-navy-900 font-normal">{{ option?.company_name }}</div>
              </div>
            </ng-template>
          </app-dropdown>
        </div>
      </div>
    </form>
  </div>
  <div class="buttons flex justify-end">
    <app-simple-button buttonStyle="color_secondary_filled" [disabled]="isSending()" (click)="save()">
      <div class="flex items-center justify-center gap-1.5">
        <span class="mb-0.5">Create</span>
        @if (isSending()) {
          <app-loading-spinner size="small" [withLogo]="false"></app-loading-spinner>
        }
      </div>
    </app-simple-button>
  </div>
</div>
